module.exports = __webpack_public_path__ + "static/media/russia.7d85333c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/russia.png
// module id = 105
// module chunks = 0